module.exports = __webpack_public_path__ + "static/media/title_bg_2.c389b958.svg";